import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, DoorOpen } from 'lucide-react';
import VisitorRegister from '../hr/visitors/VisitorRegister';
import { toast } from 'sonner';

export default function MobileVisitorCheckin() {
  const nav = useNavigate();
  return (
    <div className="px-5 pt-5 pb-24 min-h-screen bg-slate-50" data-testid="mobile-visitor-checkin">
      <button onClick={() => nav('/m')} className="text-xs text-slate-500 flex items-center gap-1 mb-4"><ArrowLeft size={14} /> Home</button>
      <header className="mb-5 bg-gradient-to-br from-[#1F7A6E] to-[#0F172A] text-white rounded-2xl p-5 shadow-lg">
        <div className="flex items-center gap-2"><DoorOpen size={20} /><h1 className="font-display text-xl font-extrabold tracking-tight">Visitor Check-in</h1></div>
        <p className="text-xs text-white/80 mt-1">Register a walk-in visitor. The host is notified instantly.</p>
      </header>
      <div className="bg-white rounded-2xl p-5 shadow-sm border border-slate-200">
        <VisitorRegister mode="walkin" embedded onSaved={() => { toast.success('Visitor registered'); nav('/m'); }} />
      </div>
    </div>
  );
}
